<div class="stripe-status-dialog">
  <div class="header-row">
    <p class="dialog-title">{{ 'Stripe' | translate }}</p>
    <button class="close-icon" type="button" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <ng-container *ngIf="data.isFullyActive; else actionRequired">
    <p class="status-message success">{{ 'Your Stripe account is connected and ready to accept payments.' | translate }}</p>

    <ng-container *ngIf="data.payoutsAtRisk">
      <p class="status-message warning">
        {{ 'Stripe needs more information to keep paying out to your bank. Payments still work, but payouts will be paused until you provide it.' | translate }}
        <span *ngIf="data.currentDeadline">
          {{ 'Due by' | translate }} {{ data.currentDeadline | date: 'mediumDate' }}.
        </span>
      </p>
      <ul class="requirements-list" *ngIf="pendingRequirements.length">
        <li *ngFor="let req of pendingRequirements">{{ req }}</li>
      </ul>
      <button class="primary-btn" type="button" (click)="continueSetup()">{{ 'Provide Information' | translate }}</button>
    </ng-container>
  </ng-container>

  <ng-template #actionRequired>
    <p class="status-message warning">{{ 'Action required — your Stripe setup is incomplete, so Stripe won\'t be offered at checkout yet.' | translate }}</p>
    <button class="primary-btn" type="button" (click)="continueSetup()">{{ 'Continue Setup' | translate }}</button>
  </ng-template>

  <a class="settings-link" (click)="openSettings()">{{ 'Want to change your Stripe settings?' | translate }}</a>
</div>
